import axiosInstance from "../../../api/AxiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getUserListRequest, getUserListRequestError, getUserListRequestSuccess } from "../../slices/User/UserListSlice";

export const UsersListApi = (page, limit, role, search, status) => async (dispatch) => {
    const queryParams = new URLSearchParams({
        page: page,
        limit: limit,
        role: role,
        search: search,
        status: status
    }).toString();

    const urlWithParams = `${endpoints.usersList}?${queryParams}`;
    try {
        dispatch(getUserListRequest());
        axiosInstance({
            method: "GET",
            url: urlWithParams,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getUserListRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getUserListRequestError(_error));
            });
    } catch (error) { }
};
